import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch
} from 'react-router-dom';

import Loader from '../Loader';
import Layout from '../Layout';
import withData from '../../utils/withData';

let dataUrl

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    // dev code
    dataUrl = '//fenway-cms.chris'
} else {
    // production code
    dataUrl = '//thefenway.com'
}

// Data to preload before site initialises
const manifest = [
  {
    name:'navigation',
    src: dataUrl + '/json/structures.json'
  },
  {
    name:'entries',
    src: dataUrl + '/json/entries.json'
  },
  {
    name:'assets',
    src:dataUrl + '/json/assets.json'
  },
  {
    name:'news',
    src:dataUrl + '/json/news.json'
  },
  {
    name:'locations',
    src:dataUrl + '/json/locations.json'
  },
  {
    name:'events',
    src:dataUrl + '/json/events.json'
  },
  {
    name:'people',
    src:dataUrl + '/json/people.json'
  },
  {
    name:'map',
    src:dataUrl + '/json/map.json'
  },
  {
    name:'amenities',
    src:dataUrl + '/json/amenities.json'
  },
  {
    name:'authors',
    src:dataUrl + '/json/authors.json'
  }
]

class App extends Component {


  constructor(props){

      super(props);
      this.state = {index:0};

      console.log("Design by GBH\nhttp://gbh.london\n\nMade by Archive\nhttp://archive.studio")
  }

  componentWillMount = () => {

      const _this = this;

  }

  render() {


    return (
      <Loader manifest={manifest}>
        <Layout {...this.props} />
      </Loader>
    );
  }
}




export default withData(App);



// WEBPACK FOOTER //
// ./src/js/components/App/index.js